export const IMAGE_RIGHTS_STATEMENT = 'I own the rights to this picture and give Identifrag permission to store, resize and display it on this website.';
export const IMAGE_MAX_BYTES = 8 * 1024 * 1024;
